import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { Link } from 'react-router-dom';

const Support: React.FC = () => {
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [issue, setIssue] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            await addDoc(collection(db, 'support'), {
                email,
                phone,
                issue,
                createdAt: Timestamp.now(),
                status: 'active',
            });
            setSubmitted(true);
        } catch (err) {
            setError('Failed to submit. Please try again.');
        }
        setLoading(false);
    };

    return (
        <div className="min-h-screen bg-gray-900 flex flex-col">
            {/* Navigation/Header */}
            <nav className="bg-gray-800 py-4">
                <div className="container mx-auto px-4 sm:px-6 flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0">
                    <div className="flex items-center gap-3">
                        <img src="/images/logo.png" alt="Fixisy Logo" className="h-8 w-8 sm:h-10 sm:w-10 object-contain" />
                        <Link to="/" className="text-xl sm:text-2xl font-bold text-cyan-400">Fixisy</Link>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 items-center">
                        <span className="text-gray-300 text-xs sm:text-sm">Contact: <a href="mailto:support@fixisy.com" className="text-cyan-400 hover:underline">support@fixisy.com</a></span>
                        <Link to="/support" className="ml-0 sm:ml-4 px-4 py-2 bg-cyan-700 text-white rounded hover:bg-cyan-800 font-semibold transition-colors w-full sm:w-auto text-center">Support</Link>
                        <Link to="/signin" className="ml-0 sm:ml-4 px-4 py-2 bg-cyan-500 text-white rounded hover:bg-cyan-600 font-semibold transition-colors w-full sm:w-auto text-center">Sign In</Link>
                    </div>
                </div>
            </nav>

            {/* Main Content */}
            <div className="flex-grow flex flex-col items-center justify-center">
                {submitted ? (
                    <div className="flex flex-col items-center justify-center min-h-[60vh]">
                        <h2 className="text-2xl font-bold mb-4">Thank you!</h2>
                        <p>Our team will contact you soon.</p>
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center min-h-[60vh] w-full">
                        <h2 className="text-2xl font-bold mb-4">Support / Feedback</h2>
                        <form onSubmit={handleSubmit} className="bg-gray-800 p-6 rounded shadow-md w-full max-w-md">
                            <div className="mb-4">
                                <label className="block mb-1">Email</label>
                                <input
                                    type="email"
                                    className="w-full p-2 rounded bg-gray-700 text-white"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-4">
                                <label className="block mb-1">Phone</label>
                                <input
                                    type="tel"
                                    className="w-full p-2 rounded bg-gray-700 text-white"
                                    value={phone}
                                    onChange={e => setPhone(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-4">
                                <label className="block mb-1">Issue / Feedback</label>
                                <textarea
                                    className="w-full p-2 rounded bg-gray-700 text-white"
                                    value={issue}
                                    onChange={e => setIssue(e.target.value)}
                                    required
                                    rows={4}
                                />
                            </div>
                            {error && <div className="text-red-500 mb-2">{error}</div>}
                            <button
                                type="submit"
                                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                                disabled={loading}
                            >
                                {loading ? 'Submitting...' : 'Submit'}
                            </button>
                        </form>
                    </div>
                )}
            </div>

            {/* Footer */}
            <footer className="py-8 bg-gray-800 mt-auto">
                <div className="container mx-auto px-4 sm:px-6">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0">
                        <div className="text-gray-400 mb-2 sm:mb-0 text-center sm:text-left">
                            © 2025 Kifayti Retail Private Limited. All rights reserved.
                        </div>
                        <div className="flex flex-col sm:flex-row gap-2 sm:gap-6 items-center">
                            <Link to="/terms" className="text-gray-400 hover:text-cyan-400">
                                Terms & Conditions
                            </Link>
                            <Link to="/privacy" className="text-gray-400 hover:text-cyan-400">
                                Privacy Policy
                            </Link>
                            <Link to="/support" className="text-gray-400 hover:text-cyan-400">
                                Support
                            </Link>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Support; 